import React, { useEffect } from 'react';
import VoiceConversationWithSpark from './VoiceConversationWithSpark';
import VoiceConversation from './VoiceConversation';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { configState } from '../recoil/configs/atoms';
import { agentState } from '../recoil';
import { getConfig } from '../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function VoiceConversationRouter() {
  const [config, setConfig] = useRecoilState(configState);
  const setCurrentAgent = useSetRecoilState(agentState);
  const navigate = useNavigate();

  const query = useQuery();
  const agent = query.get('agent');

  useEffect(() => {
    let currAgent = '';

    if (agent) {
      switch (agent.toLowerCase()) {
        case 'shell':
          currAgent = 'shell';
          break;
        case 'spark':
          currAgent = 'spark';
          break;
        case 'spark-chicago':
          currAgent = 'chicago';
          break;
        case 'laila-sxsw':
          currAgent = 'sxsw';
          break;
        case 'laila-oracle':
          currAgent = 'oracle';
          break;
        case 'laila-ny_genai':
          currAgent = 'ny_genai';
          break;
        case 'spark-sal_france':
          currAgent = 'sal_france';
          break;
        case 'spark-houston':
          currAgent = 'houston';
          break;
        case 'innovator-glc':
          currAgent = 'glc';
          break;
        case 'spark-atlanta':
          currAgent = 'atlanta';
          break;
        case 'spark-new_york':
          currAgent = 'new_york';
          break;
        case 'robin':
          currAgent = 'robin';
          break;
        case 'spark-hess':
          currAgent = 'hess';
          break;
        case 'felix':
          currAgent = 'felix';
          break;
        case 'mair':
          currAgent = 'mair';
          break;
        case 'mair-gpt':
          currAgent = 'mair-gpt';
          break;
        case 'spark-ihub':
          currAgent = 'ihub';
          break;
        default:
          console.error('Invalid agent parameter:', agent);
          navigate('*');
          break;
      }
    } else {
      // Default to spark when no agent parameter is provided
      console.log('No agent parameter provided, defaulting to spark');
      currAgent = 'spark';
      // Optionally redirect to include the agent parameter in the URL
      navigate('/voice?agent=spark', { replace: true });
    }

    // Set agent in Recoil before config loads so VoiceConversationWithSpark
    // mounts with the correct agent and the session effect runs only once.
    if (currAgent !== '') {
      setCurrentAgent(currAgent);
    }

    const fetchConfig = async () => {
      try {
        console.log('Fetching config');
        console.log('Current agent:', currAgent);
        const resp = await getConfig(currAgent);
        setConfig(resp.data || resp); // Handle both axios and fetch responses
      } catch (error) {
        console.error('Error fetching config:', error);
        // Handle error appropriately
      }
    };

    fetchConfig();
  }, [agent, navigate, setConfig, setCurrentAgent]);

  if (config?.interactive_ui === '2d') {
    // console.log('2d');
    return <VoiceConversationWithSpark />;
  } else if (config?.interactive_ui === 'voice') {
    // console.log(config);
    return <VoiceConversation />;
  } else {
    return (
      <div className="relative h-screen w-screen overflow-hidden bg-[#FFC600]">
        <div className="bg-neutral-800/bg-opacity-20 h-screen w-screen"></div>
      </div>
    );
  }
}

export default VoiceConversationRouter;
